import { render, staticRenderFns } from "./openList.vue?vue&type=template&id=2952e78e&scoped=true&"
import script from "./openList.vue?vue&type=script&lang=js&"
export * from "./openList.vue?vue&type=script&lang=js&"
import style0 from "./openList.vue?vue&type=style&index=0&id=2952e78e&prod&lang=scss&"
import style1 from "./openList.vue?vue&type=style&index=1&id=2952e78e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952e78e",
  null
  
)

export default component.exports